export default "__VITE_ASSET__DXkXVSPJ__"